
import { useState } from 'react';

export default function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  return (
    <header className="bg-white shadow-sm sticky top-0 z-50" role="banner">
      <nav className="mx-auto px-4 sm:px-6 lg:px-8" role="navigation" aria-label="Main navigation">
        <div className="flex justify-between items-center h-16 sm:h-20">
          <div className="flex items-center space-x-2 sm:space-x-4">
            <a href="/" aria-label="Curtis Waters AI Home" className="touch-target">
              <img 
                src="https://static.readdy.ai/image/6d588a7c18ffff00d30b97de4504c2f6/a641c903f8819752648aaaf6f38f657a.png" 
                alt="Curtis Waters AI Logo" 
                title="Curtis Waters AI"
                className="h-14 w-14 sm:h-20 sm:w-20 object-contain"
                width="80"
                height="80"
                loading="eager"
              />
            </a>
            <div className="text-lg sm:text-2xl font-black text-gray-900 tracking-tight" style={{ fontFamily: '"Inter", "Helvetica Neue", sans-serif' }}>
              Curtis Waters AI
            </div>
          </div>
          
          <div className="hidden md:block">
            <ul className="ml-10 flex items-baseline space-x-6 lg:space-x-8">
              <li>
                <a href="#solutions" className="text-gray-700 hover:text-red-600 px-3 py-2 text-sm font-medium transition-colors cursor-pointer touch-target" aria-label="View Solutions">
                  Solutions
                </a>
              </li>
              <li>
                <a href="#features" className="text-gray-700 hover:text-red-600 px-3 py-2 text-sm font-medium transition-colors cursor-pointer touch-target" aria-label="View Features">
                  Features
                </a>
              </li>
              <li>
                <a href="#benefits" className="text-gray-700 hover:text-red-600 px-3 py-2 text-sm font-medium transition-colors cursor-pointer touch-target" aria-label="View Benefits">
                  Benefits
                </a>
              </li>
              <li className="relative group">
                <button className="text-gray-700 hover:text-red-600 px-3 py-2 text-sm font-medium transition-colors cursor-pointer flex items-center touch-target" aria-haspopup="true" aria-expanded="false" aria-label="Other Sites menu">
                  Other Sites
                  <div className="w-4 h-4 flex items-center justify-center ml-1">
                    <i className="ri-arrow-down-s-line text-sm" aria-hidden="true"></i>
                  </div>
                </button>
                <ul className="absolute top-full left-0 mt-1 w-64 bg-white rounded-lg shadow-lg border opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-200 z-50" role="menu">
                  <li className="py-2">
                    <a href="https://CurtisWaters.com" target="_blank" rel="noopener noreferrer nofollow" className="block px-4 py-2 text-sm text-gray-700 hover:bg-red-50 hover:text-red-600 transition-colors cursor-pointer touch-target" role="menuitem">
                      Mergers &amp; Acquisitions
                    </a>
                  </li>
                  <li>
                    <a href="https://DominateWithBrand.com" target="_blank" rel="noopener noreferrer nofollow" className="block px-4 py-2 text-sm text-gray-700 hover:bg-red-50 hover:text-red-600 transition-colors cursor-pointer touch-target" role="menuitem">
                      Dominate With Brand AI
                    </a>
                  </li>
                  <li>
                    <a href="https://EntrepreneursReport.com" target="_blank" rel="noopener noreferrer nofollow" className="block px-4 py-2 text-sm text-gray-700 hover:bg-red-50 hover:text-red-600 transition-colors cursor-pointer touch-target" role="menuitem">
                      Entrepreneurs Report
                    </a>
                  </li>
                </ul>
              </li>
              <li>
                <a href="https://www.youtube.com/@CurtisWaters" target="_blank" rel="noopener noreferrer nofollow" className="text-gray-700 hover:text-red-600 transition-colors cursor-pointer touch-target" aria-label="Visit Curtis Waters YouTube channel">
                  <div className="w-5 h-5 flex items-center justify-center">
                    <i className="ri-youtube-fill text-xl" aria-hidden="true"></i>
                  </div>
                </a>
              </li>
              <li>
                <a href="#contact" className="bg-red-600 text-white px-6 py-2 rounded-lg text-sm font-medium hover:bg-red-700 transition-colors whitespace-nowrap cursor-pointer touch-target" aria-label="Get started with Curtis Waters AI">
                  Get Started
                </a>
              </li>
            </ul>
          </div>

          <div className="md:hidden">
            <button
              onClick={() => setIsMenuOpen(!isMenuOpen)}
              className="text-gray-700 hover:text-red-600 p-3 cursor-pointer touch-target"
              aria-label={isMenuOpen ? 'Close menu' : 'Open menu'}
              aria-expanded={isMenuOpen}
              aria-controls="mobile-menu"
            >
              <div className="w-6 h-6 flex items-center justify-center">
                <i className={`ri-${isMenuOpen ? 'close' : 'menu'}-line text-2xl`} aria-hidden="true"></i>
              </div>
            </button>
          </div>
        </div>

        {isMenuOpen && (
          <div className="md:hidden" id="mobile-menu">
            <nav className="px-2 pt-2 pb-3 space-y-1 bg-white border-t" role="navigation" aria-label="Mobile navigation">
              <a href="#solutions" className="block px-4 py-3 text-base text-gray-700 hover:text-red-600 hover:bg-gray-50 rounded-lg cursor-pointer touch-target">
                Solutions
              </a>
              <a href="#features" className="block px-4 py-3 text-base text-gray-700 hover:text-red-600 hover:bg-gray-50 rounded-lg cursor-pointer touch-target">
                Features
              </a>
              <a href="#benefits" className="block px-4 py-3 text-base text-gray-700 hover:text-red-600 hover:bg-gray-50 rounded-lg cursor-pointer touch-target">
                Benefits
              </a>
              <div className="border-t pt-2 mt-2">
                <p className="px-4 py-2 text-xs font-semibold text-gray-500 uppercase tracking-wider">Other Sites</p>
                <a href="https://CurtisWaters.com" target="_blank" rel="noopener noreferrer nofollow" className="block px-4 py-3 text-base text-gray-700 hover:text-red-600 hover:bg-gray-50 rounded-lg cursor-pointer touch-target">
                  Mergers &amp; Acquisitions
                </a>
                <a href="https://DominateWithBrand.com" target="_blank" rel="noopener noreferrer nofollow" className="block px-4 py-3 text-base text-gray-700 hover:text-red-600 hover:bg-gray-50 rounded-lg cursor-pointer touch-target">
                  Dominate With Brand AI
                </a>
                <a href="https://EntrepreneursReport.com" target="_blank" rel="noopener noreferrer nofollow" className="block px-4 py-3 text-base text-gray-700 hover:text-red-600 hover:bg-gray-50 rounded-lg cursor-pointer touch-target">
                  Entrepreneurs Report
                </a>
              </div>
              <a href="https://www.youtube.com/@CurtisWaters" target="_blank" rel="noopener noreferrer nofollow" className="flex items-center px-4 py-3 text-base text-gray-700 hover:text-red-600 hover:bg-gray-50 rounded-lg cursor-pointer touch-target">
                <div className="w-5 h-5 flex items-center justify-center mr-2">
                  <i className="ri-youtube-fill text-xl" aria-hidden="true"></i>
                </div>
                YouTube Channel
              </a>
              <a href="#contact" className="block px-4 py-3 text-base text-red-600 font-medium hover:bg-red-50 rounded-lg cursor-pointer touch-target mt-2">
                Get Started
              </a>
            </nav>
          </div>
        )}
      </nav>
    </header>
  );
}